import {
  cardImageFromVinoDataWineOffer,
  roundelsImageFromVinoDataWineOffer,
  wideHeroImageFromVinoDataOffer,
} from "./images";
import { generateStorefrontImage } from "../../utils/generate-storefront-image";
import { isMultiVinoDataWineSKU, isSellableVinoDataWineSKU } from "./sku";

import { OfferCardProps } from "../../components/offer-card";
import { VinoDataOffer } from "../../types/vino-data-types";
import { awardsFromVinoDataWineSKU } from "./awards";
import { isFlagEnabled } from "../../utils/is-flag-enabled";
import { priceDescriptionFromVinoDataOffer } from "./price-description";
import { shouldShowDiscountBadge } from "./discount-badge";
import { urgencyMessageFromVinoDataOffer } from "./urgency-message";
import { bottleShapeFromVinoDataSKU } from "./shape";

export const offerCardPropsFromVinoDataOffer = (
  offer: VinoDataOffer
): OfferCardProps => {
  const {
    bigcommerceId,
    discountPercentage,
    discountDollarValue,
    discountDisplay,
    displayFlags,
    displayPrice,
    endsAt,
    region,
    sku,
    backgroundColor,
    name,
    route,
    offerType,
    objectID,
    id,
    currency,
    discount,
    inventoryStatus,
    packSize,
    country,
    category,
    style,
    variant,
    varietal,
    vintage,
    preservatives,
    brand,
    is_wine,
    isSpirit,
    secret,
    tiersEligible,
    styles,
    isMixed,
    tags,
    productCardLayout,
    cardBackgroundImage,
    tagLine,
    subTagLine,
  } = offer;
  const baseUrl =
    offer.baseUrl && offer.baseUrl.endsWith("/")
      ? offer.baseUrl.slice(0, -1)
      : offer.baseUrl;

  const isSoldOut = !isSellableVinoDataWineSKU(sku);

  return {
    objectID: objectID || id,
    name,
    productId: bigcommerceId,
    awards: awardsFromVinoDataWineSKU(sku, 50),
    discountPercentage,
    discountDollarValue,
    discountDisplay,
    endsAt: endsAt ? new Date(endsAt) : undefined,
    horizontalBadges: isMixed,
    price: displayPrice,
    priceDescription: priceDescriptionFromVinoDataOffer(offer),
    region,
    unitRRP: sku?.unitRRP,
    packRRP: sku?.packRRP,
    showPriceDrop: isFlagEnabled(displayFlags, "SHOW_PRICEDROP"),
    showCountdown: isFlagEnabled(displayFlags, "SHOW_COUNTDOWN"),
    showAwardBadges: !isFlagEnabled(displayFlags, "HIDE_AWARDS_AND_RATINGS"),
    hideRRP: isFlagEnabled(displayFlags, "HIDE_RRP"),
    hideVIMExclusive: isFlagEnabled(displayFlags, "HIDE_VIM_EXCLUSIVE"),
    showDiscountBadge: shouldShowDiscountBadge(offer),
    roundelsImage: roundelsImageFromVinoDataWineOffer(offer),
    wideHeroImage: wideHeroImageFromVinoDataOffer(offer),
    cardImage: cardImageFromVinoDataWineOffer(offer),
    urgencyMessage: urgencyMessageFromVinoDataOffer(offer, isSoldOut, isSpirit),
    isMixed,
    isSoldOut,
    tagLine,
    subTagLine,
    backgroundColor,
    offerType,
    route: {
      slug: route?.slug,
      path: route?.path,
    },
    sku: sku,
    category,
    currency,
    discount,
    inventoryStatus,
    url: baseUrl
      ? `${baseUrl}/${
          isSpirit
            ? `spirits/${category.toLowerCase()}`
            : is_wine
            ? "wines"
            : "products"
        }/${route?.slug}`
      : `${baseUrl}`,
    packSize,
    country,
    offerStyle: style,
    offerVariant: variant,
    varietal,
    preservatives,
    vintage,
    brand,
    is_wine,
    isSpirit,
    secret,
    tiersEligible,
    styles,
    bottleShape: bottleShapeFromVinoDataSKU(sku),
    tags,
    productCardLayout,
    cardBackgroundImage: cardBackgroundImage && cardBackgroundImage.size > 0 ? cardBackgroundImage.url : undefined,
  };
};
